import classes from "./InputField.module.css";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { useState } from "react";

const InputField = ({className, type, placeholder, icon, onChange, value, name, disabled, children, label, innerClass, onClick, role}) => {
  return (
    <div className={`${classes.wrapper} ${className}`} >
      {label && <label>{label}</label>}
      <div className={`${classes.inputContainer} d-flex align-items-center gap-2 ${innerClass}`} onClick={onClick} role={role}>
        <div className="d-flex align-items-center justify-content-between w-100">{children ? children : <input type={type} placeholder={placeholder} onChange={onChange} value={value} name={name} disabled={disabled}/>} {icon}</div>
      </div>
    </div>
  );
};

export default InputField;
